import React from 'react'
import SEO from "../../common/SEO";
import HeaderOne from '../../common/header/HeaderOne';
import HeaderTopBar from '../../common/header/HeaderTopBar';
import FooterOne from '../../common/footer/FooterOne';
import Copyright from '../../common/footer/Copyright';
import PrivacyPolicy from '../../components/others/PrivacyPolicy';



const Login = () => {
    return (
        <>
            <SEO title="Privacy and Policy" />
            <main className="page-wrapper">
                <HeaderTopBar />
                <HeaderOne btnStyle="btn-small" HeaderSTyle="header-transparent" />

                {/* This is the Service Categories Area */}
                <div className="rwt-advance-tab-area rn-section-gap d-flex justify-content-center">
                    <div className="w-100" style={{ maxWidth: "60%" }}>
                        <div className="container">
                            <PrivacyPolicy />
                        </div>
                    </div>
                </div>








                <FooterOne />
                <Copyright />
            </main>

        </>
    )
}

export default Login
